import { render, staticRenderFns } from "./MenuItemForm.vue?vue&type=template&id=79d3f86a&scoped=true&"
import script from "./MenuItemForm.vue?vue&type=script&lang=js&"
export * from "./MenuItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3f86a",
  null
  
)

export default component.exports